import React from 'react';
import { MapPin, Store } from 'lucide-react';

const OrderDeliveryInfo = ({ order }) => {
  if (order.delivery_type === 'pickup') {
    if (!order.store_name) return null;
    return (
      <div className="flex items-center space-x-2 text-sm">
        <Store className="w-4 h-4 text-gray-400 flex-shrink-0" />
        <span className="text-gray-600">自提门店：{order.store_name}</span>
      </div>
    );
  }

  if (!order.delivery_address) return null;

  const mapUrl = 'https://www.google.com/maps/dir/?api=1&destination=' + order.delivery_latitude + ',' + order.delivery_longitude;

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium text-gray-700">配送信息</p>
        {order.delivery_latitude && order.delivery_longitude && (
          <a href={mapUrl} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="text-xs text-blue-600 hover:underline flex items-center gap-1">
            <MapPin className="w-3 h-3" />
            导航
          </a>
        )}
      </div>
      <div className="flex items-start space-x-2 text-sm">
        <MapPin className="w-4 h-4 text-gray-400 mt-0.5 flex-shrink-0" />
        <span className="text-gray-600">{order.delivery_address}</span>
      </div>
      {(order.customer_name || order.customer_phone) && (
        <div className="flex items-center space-x-4 text-sm text-gray-600">
          {order.customer_name && <span>联系人：{order.customer_name}</span>}
          {order.customer_phone && (
            <a href={'tel:' + order.customer_phone} onClick={e => e.stopPropagation()} className="text-blue-600 hover:underline">
              {order.customer_phone}
            </a>
          )}
        </div>
      )}
      {order.door_photo && (
        <div>
          <p className="text-xs text-gray-500 mb-1">门牌照片</p>
          <img src={order.door_photo} alt="门牌" className="w-24 h-20 object-cover rounded-lg border border-gray-200 cursor-pointer" onClick={e => { e.stopPropagation(); window.open(order.door_photo, '_blank'); }} />
        </div>
      )}
    </div>
  );
};

export default OrderDeliveryInfo;